import { Link, NavLink } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import Tema from "./Tema.jsx";
import Instalar from "./Instalar.jsx";
import { VIGENCIA } from "../data/fiscal.js";

const ENLACES_PIE = [
  { to: "/acerca-de", texto: "Acerca de" },
  { to: "/contacto", texto: "Contacto" },
  { to: "/aviso-de-privacidad", texto: "Privacidad" },
  { to: "/terminos-y-condiciones", texto: "Términos" },
];

const ATAJOS = [
  { to: "/calculadora-de-iva", texto: "IVA" },
  { to: "/calculadora-sueldo-neto-imss-isr", texto: "Sueldo neto" },
  { to: "/simulador-credito-infonavit", texto: "INFONAVIT" },
  { to: "/conversor-de-divisas", texto: "Divisas" },
];

export default function Layout({ children }) {
  return (
    <div className="flex min-h-[100dvh] flex-col">
      <a
        href="#contenido"
        className="boton boton-primario sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50"
      >
        Saltar al contenido
      </a>

      <header className="no-imprimir borde superficie sticky top-0 z-30 border-b backdrop-blur">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-4 py-3">
          <Link
            to="/"
            className="shrink-0 py-2 text-lg font-extrabold tracking-tight transition hover:opacity-80"
          >
            tu-kit<span className="acento">.com</span>
          </Link>

          {/* Las cuatro más buscadas, siempre a un clic. */}
          <nav aria-label="Atajos" className="hidden items-center gap-1 md:flex">
            {ATAJOS.map((a) => (
              <NavLink
                key={a.to}
                to={a.to}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-1.5 text-sm font-medium transition ${
                    isActive
                      ? "bg-[color:var(--acento-suave)] text-[color:var(--acento-texto)]"
                      : "texto-2 hover:bg-[color:var(--superficie-2)] hover:text-[color:var(--texto)]"
                  }`
                }
              >
                {a.texto}
              </NavLink>
            ))}
          </nav>

          <div className="flex shrink-0 items-center gap-1">
            {/* Solo en la app instalada: cada herramienta es su propia app, pero siempre hay camino de vuelta. */}
            <Link to="/" className="solo-instalada borde rounded-full border px-3 py-1.5 text-xs font-semibold">
              Más herramientas
            </Link>
            <Instalar />
            <span className="borde texto-3 hidden rounded-full border px-2.5 py-1 text-2xs font-medium lg:inline">
              {VIGENCIA.etiqueta}
            </span>
            <Tema />
          </div>
        </div>
      </header>

      <main id="contenido" className="mx-auto flex w-full max-w-6xl flex-1 flex-col gap-7 px-4 pb-16">
        {children}
      </main>

      <footer className="no-imprimir borde superficie mt-auto border-t">
        <div className="mx-auto w-full max-w-6xl px-4 py-8">
          <p className="texto-2 flex items-center justify-center gap-2 text-center text-sm">
            <ShieldCheck className="acento h-4 w-4 shrink-0" aria-hidden="true" />
            Tus cálculos ocurren en tu navegador. Lo que escribes no se envía a ningún servidor.
          </p>

          <nav aria-label="Enlaces del pie" className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm">
            {ENLACES_PIE.map((e) => (
              <NavLink key={e.to} to={e.to} className="texto-2 transition hover:text-[color:var(--acento-texto)]">
                {e.texto}
              </NavLink>
            ))}
          </nav>

          <p className="texto-3 mt-6 text-center text-2xs">
            © {new Date().getFullYear()} tu-kit.com · Las calculadoras son orientativas y no sustituyen
            la asesoría de un profesional fiscal, financiero o de salud.
          </p>
          <p className="texto-3 mt-2 text-center text-2xs">
            Powered by <a href="https://nortiacreative.com" rel="noopener" className="underline">nortiacreative.com</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
